import React from 'react'
import HuellaDialog from '../containers/HuellaDialog'
import Huella from '../../../models/huella/huella'
import ParametroText from '../../../models/parametro/parametro_text'

import { toast } from 'react-toastify'

export function openDialogHuella (tipo) {
  return (dispatch, getState) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'HUELLA_DIGITAL'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'HUELLA_DIGITAL',
      title: 'Huella Digital',
      maxWidth: 'xs',
      showPrint: false,
      content: <HuellaDialog tipo={tipo} />,
      cancelCallback: cancelCallback
    })
  }
}

export function closeDialogHuella () {
  return (dispatch, getState) => {
    dispatch({
      type: 'CLOSE_DIALOG',
      id: 'HUELLA_DIGITAL'
    })
  }
}

export function conectar (tipo) {
  return (dispatch, getState) => {
    if (tipo !== null) {
      dispatch({ type: 'RESET_PERITO_AUTORIZANTE' })
      dispatch({ type: 'RESET_ENTREGADOR_AUTORIZANTE' })
      dispatch({ type: 'BUSCAR_DISPOSITIVO' })
      dispatch({ type: 'REINTENTAR', reintentar: false })
      ParametroText.getByNombre(tipo)
        .then((dispositivo) => {
          console.log('Dispositivo', dispositivo)
          if (dispositivo !== null) {
            dispatch({ type: 'DISPOSITIVO_ENCONTRADO' })
            dispatch(conectarDispositivo(dispositivo.valor, tipo))
          } else {
            // No esta en Parameters
            dispatch({ type: 'REINTENTAR', reintentar: true })
            toast.info(`Imposible conectar con el dispositivo ${tipo}`, { autoClose: false })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    } else {
      // Sin dispositivo
      toast.info(`Dispositivo desconocido`, { autoClose: false })
    }
  }
}

export function conectarDispositivo (ip, tipo) {
  return (dispatch, getState) => {
    if (ip !== null) {
      dispatch({ type: 'CONECTAR_DISPOSITIVO' })
      dispatch(obtenerHuella(ip, tipo))
    } else {
      // Sin ip
      toast.info(`Imposible conectar con dispositivo desconocido`, { autoClose: false })
    }
  }
}

export function obtenerHuella (ip, tipo) {
  return (dispatch, getState) => {
    if (tipo != null) {
      dispatch({ type: 'BUSCAR_DISPOSITIVO' })
      if (ip != null) {
        dispatch({ type: 'OBTENER_HUELLA' })
        if (tipo.substr(0, 1) === 'P') {
          return Huella.getPerito(ip)
            .then((data) => {
              console.log('Perito', data)
              if (data && data !== undefined) {
                dispatch({ type: 'PERITO_AUTORIZANTE',
                  perito: data.usuario,
                  nombrePerito: data.nombre
                })
                dispatch({ type: 'MOSTRAR_SNACK', mostrarSnack: true })
                dispatch({
                  type: 'CLOSE_DIALOG',
                  id: 'HUELLA_DIGITAL'
                })
                toast.info(`Perito autorizante ${data.nombre}`)
              } else {
                dispatch({ type: 'REINTENTAR', reintentar: true })
                toast.info(`No se reconoce la huella digital como Perito`, { autoClose: false })
              }
            })
            .catch((error) => {
              console.log(error)
            })
        } else if (tipo.substr(0, 1) === 'E') {
          return Huella.getEntregador(ip)
            .then((data) => {
              console.log('Entregador', data)
              if (data && data !== undefined) {
                dispatch({ type: 'ENTREGADOR_AUTORIZANTE',
                  entregador: data.usuario,
                  nombreEntregador: data.nombre
                })
                dispatch({ type: 'MOSTRAR_SNACK', mostrarSnack: true })
                dispatch({
                  type: 'CLOSE_DIALOG',
                  id: 'HUELLA_DIGITAL'
                })
                toast.info(`Entregador autorizante ${data.nombre}`)
              } else {
                dispatch({ type: 'REINTENTAR', reintentar: true })
                toast.info(`No se reconoce la huella digital como Entregador`, { autoClose: false })
              }
            })
            .catch((error) => {
              console.log(error)
            })
        }
      } else {
        // Sin ip
        dispatch({ type: 'REINTENTAR', reintentar: true })
        toast.info(`Imposible conectar con el dispositivo ${tipo}`, { autoClose: false })
      }
    } else {
      // Sin tipo
      dispatch({ type: 'REINTENTAR', reintentar: true })
      toast.info(`Imposible conectar con dispositivo desconocido`, { autoClose: false })
    }
  }
}

export async function obtenerHuellaDigital (tipo) {
  if (tipo !== null) {
    const dispositivo = await ParametroText.getByNombre(tipo)
    console.log('Dispositivo', dispositivo)
    if (dispositivo !== null) {
      const ip = dispositivo.valor
      if (ip != null) {
        if (tipo.substr(0, 1) === 'P') {
          const data = await Huella.getPerito(ip)
          console.log('Perito', data)
          if (data && data !== undefined) {
          // dispatch({ type: 'PERITO_AUTORIZANTE',
          //   perito: data.usuario,
          //   nombrePerito: data.nombre
          // })
            toast.info(`Perito autorizante ${data.nombre}`)
            return data
          } else {
            toast.info(`No se reconoce la huella digital como Perito`)
          }
        } else if (tipo.substr(0, 1) === 'E') {
          const data = await Huella.getEntregador(ip)
          console.log('Entregador', data)
          if (data && data !== undefined) {
          // dispatch({ type: 'ENTREGADOR_AUTORIZANTE',
          //   entregador: data.usuario,
          //   nombreEntregador: data.nombre
          // })
            toast.info(`Entregador autorizante ${data.nombre}`)
            return data
          } else {
            toast.info(`No se reconoce la huella digital como Entregador`)
          }
        }
      } else {
      // Sin ip
        toast.info(`Imposible conectar con el dispositivo ${tipo}`, { autoClose: false })
      }
    } else {
    // No esta en Parameters
      toast.info(`Imposible conectar con el dispositivo ${tipo}`, { autoClose: false })
    }
  } else {
  // Sin dispositivo
    toast.info(`Dispositivo desconocido`, { autoClose: false })
  }
}
